import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import {
  selectVaultsDetailsByChainID,
} from "../store/vaults";
import { sortByTVL, sortByAPR, sortByBalance } from '../utils/filters';
import { VaultItem } from '../pages/components/VaultItem';
import { utils } from 'ethers';

export const VaultsList = ({ sortOption, tokenFilter, networkFilter }: { sortOption: string; tokenFilter: string | undefined; networkFilter: string | undefined; }) => {
  const mainVaultsDetails = useSelector(selectVaultsDetailsByChainID(1));
  const optimismVaultsDetails = useSelector(selectVaultsDetailsByChainID(10));
  const polygonVaultsDetails = useSelector(selectVaultsDetailsByChainID(137));
  const allVaultsDetails = useMemo(() => {
    return [
      ...Object.keys(mainVaultsDetails).map(key => mainVaultsDetails[key]) ?? [],
      ...Object.keys(optimismVaultsDetails).map(key => optimismVaultsDetails[key]) ?? [],
      ...Object.keys(polygonVaultsDetails).map(key => polygonVaultsDetails[key]) ?? [],
    ];
  }, [mainVaultsDetails, optimismVaultsDetails, polygonVaultsDetails]);
  const networkFilteredVaults = useMemo(() => {
    switch (networkFilter) {
      case "1":
        return [...Object.keys(mainVaultsDetails).map(key => mainVaultsDetails[key]) ?? []];
      case "10":
        return [...Object.keys(optimismVaultsDetails).map(key => optimismVaultsDetails[key]) ?? []];
      case "137":
        return [...Object.keys(polygonVaultsDetails).map(key => polygonVaultsDetails[key]) ?? []];
      default:
        return allVaultsDetails;
    }
  }, [mainVaultsDetails, networkFilter, optimismVaultsDetails, polygonVaultsDetails, allVaultsDetails]);
  const filteredVaults = useMemo(() => {
    if(tokenFilter) {
      return networkFilteredVaults.filter(
        (vault) =>
          utils.getAddress(vault.token0.address) ===
            utils.getAddress(tokenFilter) ||
          utils.getAddress(vault.token1.address) ===
            utils.getAddress(tokenFilter)
      );
    } else
      return networkFilteredVaults;
  }, [networkFilteredVaults, tokenFilter]);
  const sortedAndFilteredVaults = useMemo(() => {
    switch (sortOption) {
      case "TVL":
        return filteredVaults.slice().sort(sortByTVL);
      case "APR":
        return filteredVaults.slice().sort(sortByAPR);
      case "Balance":
        return filteredVaults.slice().sort(sortByTVL).sort(sortByBalance);
      default:
        return filteredVaults.slice().sort(sortByTVL);
    }
  }, [filteredVaults, sortOption]);

  return (
    <div>
      {
        sortedAndFilteredVaults.map((vault, index) => {
          return <VaultItem key={index} vault={vault} />
        })
      }
    </div>
  )
}